function keyTranslateFilter() {
    'ngInject';

    return function (input) {
        const upper_case = angular.uppercase(input);
        const remove_punctuations = upper_case.replace(/[\.,-\/#!$%\^&\*;:{}=\-_`~()]/g, '');
        const add_underscore = remove_punctuations.replace(/\ /g, '_');
        return add_underscore;
    };
}

angular
    .module('BB')
    .filter('key_translate', keyTranslateFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/key_translate.filter.js